"use strict";
import { useAccountDrawer } from "components/AccountDrawer/MiniPortfolio/hooks";
import { createContext, useContext } from "react";
import { useLocation } from "react-router-dom";
import { CONNECTION_PROVIDER_IDS } from "uniswap/src/constants/web3";
import { logger } from "utilities/src/logger/logger";
import { UserRejectedRequestError } from "viem";
import { useConnect as useConnectWagmi } from "wagmi";
const ConnectionContext = createContext(void 0);
export function ConnectionProvider({ children }) {
  const { pathname } = useLocation();
  const accountDrawer = useAccountDrawer();
  const connection = useConnectWagmi({
    mutation: {
      onMutate({ connector }) {
        logger.debug("useConnect", "ConnectionProvider", `Connection activating: ${connector.name}`);
      },
      onSuccess(_, { connector }) {
        logger.debug("useConnect", "ConnectionProvider", `Connection activated: ${connector.name}`);
        if ("id" in connector && connector.id === CONNECTION_PROVIDER_IDS.EMBEDDED_WALLET_CONNECTOR_ID) {
          accountDrawer.open();
        } else {
          accountDrawer.close();
        }
      },
      onError(error, { connector }) {
        if (error instanceof UserRejectedRequestError) {
          connection.reset();
          return;
        }
        logger.warn("useConnect", "ConnectionProvider", `Connection failed: ${connector.name}`);
      }
    }
  });
  return <ConnectionContext.Provider value={connection}>{children}</ConnectionContext.Provider>;
}
export function useConnect() {
  const value = useContext(ConnectionContext);
  if (!value) {
    throw new Error("useConnect must be used within a ConnectionProvider");
  }
  return value;
}
